import { Bootgrid } from "./bootgrid";

interface KeyboardShortcutMapping {
    key: string;
    action: () => void;
}

export class BootgridKeyboardShortcutManager {
    private bootgrids: Bootgrid[];
    private mainBootgrid: Bootgrid | null = null;
    private shortcuts: KeyboardShortcutMapping[] = [];

    constructor(bootgrids: Bootgrid[]) {
        this.bootgrids = bootgrids;
        this.mainBootgrid = bootgrids.find((b) => b.isMainBootgrid());

        this.shortcuts = [
            {
                key: "ctrl+i",
                action: () => {
                    if (!this.mainBootgrid) return;
                    this.mainBootgrid.newRecordHandler();
                },
            },
            {
                key: "ctrl+e",
                action: () => {
                    if (!this.mainBootgrid) return;
                    this.mainBootgrid.editRecordHandler(this.mainBootgrid.getSelectedRowIds()[0]);
                },
            },
            {
                key: "delete",
                action: () => {
                    if (!this.mainBootgrid) return;
                    this.mainBootgrid.deleteSelectedRowsHandler();
                },
            },
            {
                key: "ctrl+alt+i",
                action: () => {
                    const activeSubBootgrid = this.getActiveSubBootgrid();
                    if (!activeSubBootgrid) return;
                    activeSubBootgrid.newRecordHandler();
                },
            },
            {
                key: "ctrl+alt+í",
                action: () => {
                    const activeSubBootgrid = this.getActiveSubBootgrid();
                    if (!activeSubBootgrid) return;
                    activeSubBootgrid.newRecordHandler();
                },
            },
            {
                key: "ctrl+alt+e",
                action: () => {
                    const activeSubBootgrid = this.getActiveSubBootgrid();
                    if (!activeSubBootgrid) return;
                    activeSubBootgrid.editRecordHandler(activeSubBootgrid.getSelectedRowIds()[0]);
                },
            },
            {
                key: "ctrl+alt+é",
                action: () => {
                    const activeSubBootgrid = this.getActiveSubBootgrid();
                    if (!activeSubBootgrid) return;
                    activeSubBootgrid.editRecordHandler(activeSubBootgrid.getSelectedRowIds()[0]);
                },
            },
            {
                key: "alt+delete",
                action: () => {
                    const activeSubBootgrid = this.getActiveSubBootgrid();
                    if (!activeSubBootgrid) return;
                    activeSubBootgrid.deleteSelectedRowsHandler();
                },
            },
        ];

        document.addEventListener("keydown", this.handleKeyDown);
    }
    private getActiveSubBootgrid() {
        const container = $("#bottomTabContainer").parent();
        const activeContainer = container.find(".table-container.active");
        const activeBootgridMenuItemName = activeContainer.find("table").data("menu-item-name") as string;

        return this.bootgrids.find((b) => b.menuItemName == activeBootgridMenuItemName);
    }
    private handleKeyDown = (event: KeyboardEvent) => {
        if (!this.mainBootgrid) {
            return;
        }

        const target = event.target as HTMLElement;
        if (this.isInputField(target)) {
            return;
        }

        const keyCombo = this.getKeyCombo(event);
        const shortcut = this.shortcuts.find((s) => s.key === keyCombo);

        if (shortcut) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.isModalActive()) {
                shortcut.action();
            }
        }
    };

    private isModalActive() {
        const dialogModal = document.getElementById("dialogModal");

        if (dialogModal) {
            if (dialogModal.getAttribute("aria-hidden") != null && dialogModal.getAttribute("aria-hidden") === "false") {
                return true;
            }
        }

        if (document.querySelector(".modal.edit-modal")) {
            return true;
        }
    }

    private getKeyCombo(event: KeyboardEvent): string {
        const parts: string[] = [];

        if (event.ctrlKey) parts.push("ctrl");
        if (event.shiftKey) parts.push("shift");
        if (event.altKey) parts.push("alt");

        const key = event.key.toLowerCase();

        switch (key) {
            case "delete":
                parts.push("delete");
                break;
            case "enter":
                parts.push("enter");
                break;
            case "escape":
                parts.push("escape");
                break;
            default:
                if (key.length === 1) {
                    parts.push(key);
                }
                break;
        }

        return parts.join("+");
    }

    private isInputField(element: HTMLElement): boolean {
        const tagName = element.tagName.toLowerCase();
        const contentEditable = element.contentEditable === "true";

        return (
            tagName === "input" ||
            tagName === "textarea" ||
            tagName === "select" ||
            contentEditable ||
            element.closest(".editable") !== null ||
            element.closest('[contenteditable="true"]') !== null
        );
    }
}
